import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { specialsMap } from '@/data/ecocreditsday';
import { createEFPic } from '@/utils/useEFPic';
import CommonButton from '@/components/EcoCreditsDay/CommonButton';
import gtm from '@/utils/gtm';
import { signupCookie } from '@/utils/cookies/signupCookie';

const { EFPic } = createEFPic('/media/ecocredits-day/h5/');

export default function UseSpecials() {
    const { t } = useLang('ecocreditsday.pageTabs.tabB');
    const { t: t2 } = useLang('ecocreditsday');
    const { locale } = useRouter();
    const specialsData = specialsMap[locale as keyof typeof specialsMap] || specialsMap.jp;

    const handleClick = () => {
        if (locale !== 'jp') {
            gtm.push({
                event: 'uaEvent',
                event_name: 'ecocredits_button',
                type: 'Other',
                list_name: t2('pageTabs.tab4'),
                button_name: t('useSpecials.btn_text'),
            });
        }
        const url =
            locale === 'jp'
                ? 'https://www.ecoflow.com/jp/register?redirect=https://www.ecoflow.com/jp/ecocredits'
                : `https://www.ecoflow.com/${locale}/ecocredits`;
        if (locale === 'jp') {
            signupCookie?.({
                sector_name: t('useSpecials.title'),
                entry_position: 3,
            });
        }
        window.open(url);
    };

    return (
        <div className={styles.useSpecials}>
            <div className="use-specials">
                <div className="use-specials__title">{t('useSpecials.title')}</div>
                <div className="use-specials__box">
                    <div className="use-specials__list">
                        <div className="use-specials__data">
                            {specialsData.map((item: Record<string, string | string[]>, index) => (
                                <div className="use-specials__item" key={index}>
                                    <EFPic name={item.src} className="use-specials__bg" />
                                    <div className="use-specials__text">{item.title}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="use-specials__btn">
                    <CommonButton disabledAni padding="10px 14px" lineHeight="23px" borderRadius="8px" onClick={handleClick}>
                        <div className="btn-text">
                            {t('useSpecials.btn_text')}
                            <div className="svg-arrow"></div>
                        </div>
                    </CommonButton>
                </div>
            </div>
        </div>
    );
}
